import "./styles/LoanStyle.css";
import React, { Fragment, useContext, useEffect, useState } from "react";
import FContainer from "../../components/FContainer/FContainer";
import { ArrowCircleDownIcon, ArrowCircleUpIcon } from "@heroicons/react/outline";
import { useNotification } from "../../hooks/useNotification";
import { useCurrencyFormat } from "../../hooks/useCurrencyFormat";
import { useProcessor } from "../../hooks/useProcessor";
import { v4 as uuidv4 } from 'uuid'
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { size } from "lodash";
import FiconPhoneNumber from "../../components/FiconPhoneNumber/FiconPhoneNumber";
import { useFormat } from "../../hooks/useFormat";
import InfiniteScroll from 'react-infinite-scroll-component';
import { Trash } from "react-ionicons";
import { AuthContext } from "../../context/AuthContext";
import { useLoans } from '../../hooks/useLoans';
import { getWordOfDictionary } from "../../common/dictionary";

export const LoansScreen = () => {
  const { getAllLoans, UpdateLoans, totalPages } = useLoans();

  const { getNotification, updateNotificationStatus, deleteNotification } = useNotification();
  const { formatWithCurrencyISO } = useCurrencyFormat();
  const { processPayment } = useProcessor();
  const route = useNavigate()
  const { formatDateHour, formatDate2 } = useFormat();
  const [toggleState, setToggleState] = useState(1);
  const [idempotencyKey, setIdempotencyKey] = useState('');
  const [statusTab, setStatusTab] = useState('PENDING_PAYMENT');
  const [page, setPage] = useState(1);
  const [totalComplete, setTotalComplete] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const [loans, setLoans] = useState([]);
  const [totalPending, setTotalPending] = useState(0);


  const { notificationsSocket, setNotificationsSocket
  } = useContext(AuthContext);

  useEffect(() => {

    const _setLoans = async () => {
      let res = await getAllLoans(statusTab, 1)
      setPage(1)
      if (res[0]) {
        res[1].page.map(r => {
          r.idempotencyKey = uuidv4()
        })
        console.log(res[1])
        setLoans(res[1]);
      } else {
        setLoans([]);
        setLoans([]);
      }
    };


    if (!!notificationsSocket) {
      if (notificationsSocket.messageType == "FIADO_PAYMENT_CONFIRM") {
        _setLoans();
      }
    }

  }, [notificationsSocket]);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }


  useEffect(() => {
    setLoans([]);
    const _setLoans = async () => {
      let res = await getAllLoans(statusTab, 1)
      setPage(1)
      if (res[0]) {
        res[1].page.map(r => {
          r.idempotencyKey = uuidv4()
        })
        console.log(res[1])
        setLoans(res[1]);
      } else {
        setLoans([]);
      }
    };
    _setLoans();
  }, [statusTab])


  useEffect(() => {
    if (statusTab == "PENDING_PAYMENT") {
      setTotalPending(loans.totalRecords)
    } else {

    }
  }, [loans])

  const fetchMoreData = () => {
    if (page + 1 <= loans.totalPages) {
      const _getAllLoans = async () => {
        let res = await getAllLoans(statusTab, page + 1)
        setPage(page + 1)
        res[1].page = loans.page.concat(res[1].page)
        setLoans(res[1])
      }
      _getAllLoans();
    }
  };

  const nextScreen = async (event, data) => {
    if ((await UpdateLoans(data)) === true) {
      console.log(event)
      if (event == "CANCEL") {
        loans.page = loans.page.filter((item) => item.transactionNumber != data.transactionNumber)
        setTotalPending(totalPending - 1)
      } else {
        loans.page.filter((item) => item.transactionNumber == data.transactionNumber)[0].status = "IN_PROCESS_PAYMENT"
        loans.page.filter((item) => item.transactionNumber == data.transactionNumber)[0].paymentReference = data.paymentReference
      }
      Swal.fire({
        showCloseButton: true,
        icon: 'success',
        title: "Éxito",
        showConfirmButton: false,
        timer: 1500
      })
    } else {
      Swal.fire({
        showCloseButton: true,
        title: 'Advertencia',
        text: "Esta transacción ya fue procesada o expiró",
        icon: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#fd6e0d',
        iconColor: "#fd6e0d",
        confirmButtonText: 'Entendido'
      })
    }
  };

  return (
    <>
      <FContainer>
        <div className="sm:block w-full">
          <div className="border-0 border-gray-200">
            <nav className="-mb-px flex" aria-label="Tabs">
              <a
                className={classNames(
                  toggleState === 1
                    ? 'tab-active'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                  'flex-1 py-4 px-1 text-center border-b-2 font-medium text-sm cursor-pointer'
                )}
                aria-current={toggleState === 1 ? 'page' : undefined}
                onClick={() => {
                  setStatusTab('PENDING_PAYMENT')
                  toggleTab(1)
                }}
              >
                Pendientes por pago ( {!totalPending ? 0 : totalPending} )
              </a>
              <a
                className={classNames(
                  toggleState === 2
                    ? 'tab-active'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                  'flex-1 py-4 px-1 text-center border-b-2 font-medium text-sm cursor-pointer'
                )}
                aria-current={toggleState === 2 ? 'page' : undefined}
                onClick={() => {
                  setStatusTab('PAYMENT_COMPLETED')
                  toggleTab(2)
                }}
              >
                Completados
              </a>
            </nav>
          </div>

          <div className="content-tabs">
            <div
              className={toggleState === 1 ? "content  active-content" : "content"}
            >
              {
                loans &&
                <InfiniteScroll
                  dataLength={size(loans.page)}
                  next={fetchMoreData}
                  hasMore={true}
                >
                  {loans.page && (loans.page).map((loan, index) => {
                    return (
                      <div className="border w-full rounded-2xl px-2 py-3 my-2" key={index}>
                        <LoansCards loan={loan} nextScreen={nextScreen} />
                      </div>
                    )
                  })}
                </InfiniteScroll>
              }
              {
                size(loans) < 1 ?
                  <div className="flex justify-center">
                    <h2 className="text-2xl text-gray-500">No hay pendientes de pago</h2>

                  </div>
                  : null
              }
            </div>
            <div
              className={toggleState === 2 ? "content  active-content" : "content"}
            >
              {
                loans &&
                <InfiniteScroll
                  dataLength={size(loans.page)}
                  next={fetchMoreData}
                  hasMore={true}
                >
                  {loans.page && (loans.page).map((loan, index) => {
                    return (
                      <div className="border w-full rounded-2xl px-2 py-3 my-2" key={index}>
                        <LoansCards loan={loan} nextScreen={nextScreen} />
                      </div>
                    )
                  })}
                </InfiniteScroll>
              }
              {
                size(loans) < 1 ?
                  <div className="flex justify-center">
                    <h2 className="text-2xl text-gray-500">No hay completadas</h2>
                  </div>
                  : null
              }
            </div>
          </div>
        </div>
      </FContainer>
    </>
  );
}


const LoansCards = ({ loan, nextScreen }) => {
  const { formatDateHour, formatDate2 } = useFormat();
  const { formatWithCurrencyISO } = useCurrencyFormat();
  const [referenceNumber, setReferenceNumber] = useState('');

  return (
    <>
      <div className="border-0 card-notification-header">
        <h2 className="card-title border-0 w-full">
          <>
            <div
              key={loan.id}
              className="border-[1px] p-5 rounded-xl shadow-md"
            // className="relative flex items-center space-x-3 rounded-2xl bg-white px-6 py-5 shadow-sm focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 hover:border-gray-400 loan-card"
            >
              <div className="min-w-0 flex-1">
                <p className={"truncate text-sm text-primary text-right"}>{getWordOfDictionary(loan.status)}</p>
                <div className='flex justify-between mt-1'>
                  <p className="text-sm text-gray-900 flex-1 font-light">{loan.product.displayName}</p>
                  <p className="truncate text-sm flex-1 text-right font-semibold">{formatWithCurrencyISO(loan.originAmount.amount, loan.originAmount.currencyId)}</p>
                </div>
                <div className='flex justify-between mt-1'>
                  <p className="text-sm text-gray-900 flex-1 font-light">Método de pago</p>
                  <p className="truncate text-sm flex-1 text-right font-semibold">{loan.paymentMethod.displayName}</p>
                </div>

                <div className='flex justify-between mt-1'>
                  <p className="text-sm text-gray-900 flex-1 font-light">Fecha de expiración</p>
                  <p className="truncate text-sm  flex-1 text-right font-semibold">{formatDate2(loan.dueDate)}</p>
                </div>
                <div className='flex justify-between mt-1'>
                  <p className="text-sm text-gray-900 flex-1 font-light">Referencia (para mensaje)</p>
                  <p className="truncate text-sm  flex-1 text-right font-semibold">{loan.transactionNumber}</p>
                </div>
                {
                  loan.status == "IN_PROCESS_PAYMENT" || loan.status == "PAYMENT_COMPLETED" ?
                    <>
                      <div className='flex justify-between mt-1'>
                        <p className="text-sm text-gray-900 flex-1 font-light">Número de confirmación</p>
                        <p className="truncate text-sm  flex-1 text-right font-semibold">{loan.paymentReference}</p>
                      </div>
                    </> : null
                }

              </div>
            </div>
          </>
        </h2>
      </div>
      {
        loan.status == "IN_PROCESS_PAYMENT" || loan.status == "PAYMENT_COMPLETED" ?
          null :
          <>
            <div className="flex border-2">
              <input
                key={loan.id}
                type="number"
                onChange={(e) => {
                  setReferenceNumber(e.target.value)
                }}
                placeholder="Número de confirmación"
                className="button-notification bg-backgroundInput !rounded-none"
              />
              <button
                type="button"
                disabled={referenceNumber.length > 3 ? false : true}
                className={`button-notification ${referenceNumber.length > 3 ? "button-confirm" : " !cursor-default"}`}
                onClick={async () => {
                  let data = {
                    transactionNumber: loan.transactionNumber,
                    paymentReference: referenceNumber
                  }
                  nextScreen("CONFIRM", data)
                }}
              >
                Confirmar
              </button>

            </div>
            <div className="flex border-0">
              <button
                type="button"
                className="button-notification !mr-0"
                onClick={async () => {
                  let data = {
                    transactionNumber: loan.transactionNumber,
                    status: "CANCEL"
                  }
                  nextScreen("CANCEL", data)
                }}
              >
                Cancelar
              </button>

              <p className="card-description-text py-2 border-0 text-right pr-2">{`${formatDateHour(loan.createDate)}`} </p>

            </div>
          </>
      }
    </>
  );
};